interface IAttachment {
    file: File;
    isLoading: boolean;
    id: number;
}

export const processFile = (file: File, tempId: number) =>
    new Promise<IAttachment>((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            resolve({ file, isLoading: false, id: tempId });
        };

        reader.onerror = () => {
            // @ts-ignore
            console.error(`${i18next.t('processFile.error.text')} ${file.name}`);
            resolve({ file, isLoading: false, id: tempId });
        };

        reader.readAsDataURL(file);
    });
